import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRestart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.7 17.7",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M14.5,7.8c.3.6.4,1.2.4,1.9s-.1,1.3-.4,1.9-.6,1.1-1.1,1.6-1,.8-1.6,1.1-1.2.4-1.9.4h-.2v-2.1h.2c.8,0,1.4-.3,2-.8s.8-1.2.8-2-.3-1.4-.8-2-1.2-.8-2-.8h-3.2v2.1l-3.9-3.2,3.9-3.2v2.1h3.2c.7,0,1.3.1,1.9.4s1.1.6,1.6,1.1.8,1,1.1,1.6Z"
	})
});
export default SvgRestart;
